import Vue from 'vue';
import { EvaluationStatus } from '@/pipeline/stateMachine';
import * as Mixpanel from './mixpanel';

export const DEAL_STAGE_APPROVED_HUBSPOT_ID = 1475454;
export const DEAL_STAGE_DISAPPROVED_HUBSPOT_ID = 1681730;

export const dealStageIdMapping: Record<string, number> = {
  success: DEAL_STAGE_APPROVED_HUBSPOT_ID,
  retryEssay: DEAL_STAGE_DISAPPROVED_HUBSPOT_ID,
  failure: DEAL_STAGE_DISAPPROVED_HUBSPOT_ID,
};

export const applicationStatusMapping: Record<string, string> = {
  success: 'approved',
  pendingApproval: 'ready for evaluation',
  retryEssay: 'disapproved',
  failure: 'disapproved',
};

const EMAIL_ALIAS = 'used_mixpanel_email_alias';

// DEPRECATED
class Analytics {
  static identify({ id, email, name }: { id: string; email?: string; name?: string }) {
    const traits = { email, name, $email: email };
    // sem o Pocket não há como saber se a conta do accounts é a mesma: segue como deslogado
    const accountsUser = window.POCKET?.profile();
    const isSameAccountsUser = id === accountsUser?.email;

    if (isSameAccountsUser && accountsUser) {
      Mixpanel.alias(accountsUser.id.toString());
    }
    if ((isSameAccountsUser || !accountsUser) && !Vue.$cookies.get(EMAIL_ALIAS)) {
      Mixpanel.alias(id);
      Vue.$cookies.set(EMAIL_ALIAS, true, '1m', '/', '.descomplica.com.br');
    }
    Mixpanel.identify(id, traits);

    // HubSpot, Zé Spot e o perfil salvo (`d-profile`) continuam pelo Pocket
    if (window.POCKET) window.POCKET.identify(id, traits, Mixpanel.POCKET_WITHOUT_MIXPANEL);
  }

  static alias(id: string) {
    Mixpanel.alias(id);
  }

  static track(eventName: string, props: Object = {}): void {
    // `useMixpanel`/`useHubspot` iam no 2º argumento do `POCKET.track`, que é o das
    // propriedades: nunca escolheram destino (todo evento ia para os dois) e chegavam
    // ao Mixpanel e ao HubSpot como propriedade do evento. Ficam como estavam.
    const properties = {
      business_category: 'faculdade',
      category: 'faculdade',
      useMixpanel: true,
      useHubspot: true,
      ...props,
    };

    Mixpanel.track(eventName, properties);

    // HubSpot e Zé Spot continuam pelo Pocket
    if (window.POCKET) window.POCKET.track(eventName, properties, Mixpanel.POCKET_WITHOUT_MIXPANEL);
  }

  static getRawUrl(): string {
    const { host, pathname } = window.location;
    return `${host}${pathname}`;
  }

  static trackGTM(props: Object) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(props);
  }

  static trackPageView() {
    Analytics.trackMixpanel('Page View', { gt_Location: this.getRawUrl() });
  }

  static trackHubSpot(eventName: string, props: Object = {}) {
    Analytics.track(eventName, {
      useMixpanel: false,
      ...props,
    });
  }

  static trackMixpanel(eventName: string, props: Object = {}) {
    Analytics.track(eventName, {
      useHubspot: false,
      ...props,
    });
  }

  static trackApplicationStatus(
    evaluationStatus: EvaluationStatus,
    email: string,
    admissionId: number,
  ) {
    const status = evaluationStatus || '';

    Analytics.track('User Application Status', {
      processoSeletivoId: admissionId,
      email,
      applicationStatus: applicationStatusMapping[status],
      lead_status: applicationStatusMapping[status],
      deal_stage: dealStageIdMapping[status],
    });
  }

  static trackEssayEvaluationSent(
    uploadType: string,
    fileMimeType: string = '',
    email: string,
    admissionId: number,
  ) {
    let evaluationTypeSent;
    if (uploadType === 'text') evaluationTypeSent = 'Redação digitada';
    else if (uploadType === 'file') {
      if (fileMimeType.includes('image/')) evaluationTypeSent = 'Redação foto';
      else evaluationTypeSent = 'Redação arquivo';
    }

    Analytics.trackMixpanel('Evaluation Sent', {
      processoSeletivoId: admissionId,
      email,
      evaluationTypeSent,
      grad_processo_seletivo: 'Redação',
      business_category: 'faculdade',
      category: 'faculdade',
    });

    Analytics.trackHubSpot('Evaluation Sent', {
      processoSeletivoId: admissionId,
      email,
      evaluationTypeSent,
      grad_processo_seletivo: 'Redação',
      business_category: 'faculdade',
      category: 'faculdade',
    });
  }

  static trackFirstAccess() {
    Analytics.trackGTM({ event: 'first_access' });
  }
}

export default Analytics;
